'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const {sprintf} = require('dibs-strings-helper');
const FavoriteModel = require('bunsen/models/identity/Favorite');
const FavoriteCta = require('../../../components/FavoriteCta/FavoriteCta');
const FAVORITE_TRACKING = require('../../../components/FavoriteCta/trackingData');
const { variants } = require('../../constants/maytestConstants.es');

function ContactDealerFavorite({company, favoriteDealer, favoriteDealerCta, pk, uri, maytest}) {
    const favoriteCtaCopy = Object.assign({}, favoriteDealerCta, {
        confirmationTooltip: sprintf(favoriteDealerCta.confirmationTooltip, company)
    });
    const buttonClasses = classNames(
        `button-${maytest === variants.CONTACT2 ? 'small' : 'large'}`,
        'button-secondary', {
            'pdp-favorite-cta': maytest !== variants.CONTACT2,
            'maytest-contact-button': maytest === variants.CONTACT2
        });
    return (
        <div className="pdp-dealer-body-favorite-cta-container">
            <FavoriteCta
                className={buttonClasses}
                copy={favoriteCtaCopy}
                favoriteData={{
                    type: FavoriteModel.TYPE_DEALER,
                    page: uri,
                    primaryKey: pk,
                    authModalOptions: FAVORITE_TRACKING.DEALER.PDP_AUTH_MODAL
                }}
                tracking={FAVORITE_TRACKING.DEALER.PDP}
                {...favoriteDealer}
            />
        </div>
    );
}

ContactDealerFavorite.propTypes = {
    company: PropTypes.string.isRequired,
    favoriteDealer: PropTypes.object.isRequired,
    favoriteDealerCta: PropTypes.object.isRequired,
    pk: PropTypes.string.isRequired,
    uri: PropTypes.string.isRequired,
    maytest: PropTypes.string
};

module.exports = ContactDealerFavorite;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/ContactDealer/ContactDealerFavorite.jsx